export default function mobileObjectFunctions() {
  function init() {
    const mobileScreen = window.matchMedia("(max-width: 1149px)");

    function changeBuilding() {
      const btns = document.querySelectorAll(".svg-building");

      btns.forEach((btn) => {
        btn.addEventListener("click", function () {
          const iconID = btn.getAttribute("data-api-id");

          const icons = document.querySelectorAll("[data-icon]");

          icons.forEach((icon) => {
            if (icon.getAttribute("data-icon") === `${iconID}`) {
              icon.classList.remove("hidden");
            } else {
              icon.classList.add("hidden");
            }
          });
        });
      });
    }

    function handleScreenChange(e) {
      if (e.matches) {
        changeBuilding();
      }
    }

    mobileScreen.addListener(handleScreenChange);

    // Run it initially
    handleScreenChange(mobileScreen);
  }

  const isPresent = document.getElementsByClassName("objects-table");
  if (isPresent.length > 0) {
    init();
  }
}
